<div class="create-menu-group-page">
    <div class="page-header">
        <div class="d-flex justify-content-between align-items-center">
            <div>
                <h1 class="page-title">CREAR GRUPO DE MENÚ</h1>
                <p class="page-subtitle text-muted">
                    Registre un nuevo grupo. El orden define la posición en el menú lateral.
                </p>
            </div>
        </div>
    </div>
    <div class="page-content">
        <mat-card class="form-card">
            <mat-card-content>
                <form [formGroup]="form" (ngSubmit)="onSubmit()">
                    <!-- Información Básica -->
                    <div class="form-section">
                        <h6 class="section-title d-flex align-items-center mb-3">
                            <i class="ri-information-line me-2 text-primary"></i>
                            Información Básica
                        </h6>
                        <div class="form-grid basic-grid">
                            <mat-form-field appearance="outline" class="form-field">
                                <mat-label>Nombre</mat-label>
                                <input matInput formControlName="nombre" placeholder="LOGISTIC" inputmode="text" />
                                <mat-error *ngIf="form.get('nombre')?.hasError('required')">{{ getError('nombre') }}</mat-error>
                                <mat-error *ngIf="form.get('nombre')?.hasError('maxlength')">{{ getError('nombre') }}</mat-error>
                                <mat-hint>Nombre del grupo (ej: LOGISTIC, AGENCIA, DUS)</mat-hint>
                            </mat-form-field>
                            <mat-form-field appearance="outline" class="form-field">
                                <mat-label>Orden</mat-label>
                                <input matInput formControlName="orden" type="number" min="0" inputmode="numeric" />
                                <mat-error *ngIf="form.get('orden')?.hasError('required')">{{ getError('orden') }}</mat-error>
                                <mat-error *ngIf="form.get('orden')?.hasError('min')">{{ getError('orden') }}</mat-error>
                                <mat-hint>Menor número = aparece antes en el menú</mat-hint>
                            </mat-form-field>
                        </div>

                        <div class="integration-row">
                            <mat-checkbox formControlName="integration">Sistema Integrado</mat-checkbox>
                            <mat-form-field appearance="outline" class="form-field" *ngIf="form.get('integration')?.value">
                                <mat-label>URL del Token</mat-label>
                                <input matInput formControlName="url_token" placeholder="https://satelite.ejemplo.cl/embed-token" inputmode="url" />
                                <mat-error *ngIf="form.get('url_token')?.hasError('maxlength')">{{ getError('url_token') }}</mat-error>
                                <mat-hint>URL del endpoint que emite el token para este sistema integrado</mat-hint>
                            </mat-form-field>
                            <mat-form-field appearance="outline" class="form-field" *ngIf="form.get('integration')?.value">
                                <mat-label>API Key de pases (X-API-Key)</mat-label>
                                <input matInput formControlName="api_key" type="password" autocomplete="new-password" placeholder="Clave entregada por el proveedor" />
                                <mat-error *ngIf="form.get('api_key')?.hasError('maxlength')">{{ getError('api_key') }}</mat-error>
                                <mat-hint>Credencial que se envía como X-API-Key al pedir el token. No se vuelve a mostrar una vez guardada.</mat-hint>
                            </mat-form-field>
                            <mat-form-field appearance="outline" class="form-field" *ngIf="form.get('integration')?.value">
                                <mat-label>API Key de sesiones (X-API-Key)</mat-label>
                                <input matInput formControlName="session_api_key" type="password" autocomplete="new-password" placeholder="Clave entregada por el proveedor" />
                                <mat-error *ngIf="form.get('session_api_key')?.hasError('maxlength')">{{ getError('session_api_key') }}</mat-error>
                                <mat-hint>Credencial para cerrar y alargar sesiones embebidas (distinta de la de pases). No se vuelve a mostrar una vez guardada.</mat-hint>
                            </mat-form-field>
                        </div>
                    </div>

                    <!-- Botones de acción -->
                    <div class="form-actions">
                        <button type="button" mat-button (click)="onCancel()" [disabled]="isLoading">
                            <i class="ri-arrow-left-line me-2"></i>
                            Cancelar
                        </button>
                        <button type="submit" mat-raised-button color="primary" [disabled]="form.invalid || isLoading">
                            <span *ngIf="!isLoading">
                                <i class="ri-add-line me-2"></i>
                                Crear Grupo
                            </span>
                            <span *ngIf="isLoading">
                                <i class="ri-loader-4-line animate-spin me-2"></i>
                                Creando...
                            </span>
                        </button>
                    </div>
                </form>
            </mat-card-content>
        </mat-card>
    </div>
</div>
